<template>
    <div class="container padding">
        <h1>{{$t('page.report.headline')}}</h1>
        <div class="grid grid--9-3">
        <div class="content__main">
            <p>{{$t('page.report.text')}}</p>
            <div class="abuse__wrapper">
                <dropdown @update-meta="updateMetaValue" :list="abuseReasons" :object="abuseObject" :validator="validator.drp_reason" :title="$t('page.report.reason')" :text="$t('page.report.reason_text')"></dropdown>
                <textarea v-model="abuseText" class="input--textarea" :class="{'input--error' : validator.txt_description.error}" id="answer" rows="3"></textarea>
                <p v-if="validator.txt_description.error" class="message--error">{{validator.txt_description.message}}</p>
                <btn @click="submitAbuse()" :class="'btn--right btn--offset-top'" :text="$t('page.report.submit')" />
            </div>
        </div>
        <aside>
            <template v-if="!plugins">
                <plugin-entry-placeholder
                    v-for="plugin in 1"
                    :key="plugin"></plugin-entry-placeholder>
                </template>
            <template v-else>
                <plugin-entry
                    v-for="plugin in plugins"
                    :key="plugin.id"
                    :id="plugin.id"
                    :logo="plugin.image"
                    :size="128"
                    :title="plugin.name"
                    :short_description="plugin.short_description"
                    :technologies="plugin.technologies"
                    :brands="plugin.brands"
                    :rating="plugin.rating"
                    :creator="plugin.creator"
                    :highlight="plugin.highlight"
                    :certified="plugin.certified"
                    :type="plugin.type"></plugin-entry>
            </template>
        </aside>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import PluginEntry from '@/components/PluginEntry.vue';
    import PluginEntryPlaceholder from '@/components/PluginEntryPlaceholder.vue';
    import Dropdown from '@/components/Dropdown.vue';
    import Btn from '@/components/Button.vue';

    export default {
        components: {
            PluginEntry,
            PluginEntryPlaceholder,
            Dropdown,
            Btn,
        },

        data() {
            return {
                abuseText: '',
                plugins: null,
                plugin_id: window.location.href.split('/')[4].substring(window.location.href.split('/')[4].lastIndexOf('-') + 1),
                abusePluginFilter: {
                    plugin_id: window.location.href.split('/')[4].substring(window.location.href.split('/')[4].lastIndexOf('-') + 1),
                },
                abuseObject: {
                    id: 0,
                },
                abuseReasons: {
                    1: {
                        id: 1,
                        value: this.$t('page.report.categories.not_working'),
                    },
                    2: {
                        id: 2,
                        value: this.$t('page.report.categories.incorrect_display'),
                    },
                    3: {
                        id: 3,
                        value: this.$t('page.report.categories.harm_data'),
                    },
                    4: {
                        id: 4,
                        value: this.$t('page.report.categories.copyright'),
                    },
                    5: {
                        id: 5,
                        value: this.$t('page.report.categories.other'),
                    },
                },
                validator: {
                    drp_reason: {
                        error: false,
                        message: '',
                    },
                    txt_description: {
                        error: false,
                        message: '',
                    }
                }
            }
        },

        methods: {
            submitAbuse() {
                var success = true;
                if(this.abuseText == "" || this.abuseText == null) {
                    success = false;
                    this.validator.txt_description = {
                        error: true,
                        message: 'Field must not be empty'
                    }
                }else {
                    this.validator.txt_description = {
                        error: false,
                        message: '',
                    }
                }

                if(this.abuseObject.id == 0) {
                    success = false;
                    this.validator.drp_reason = {
                        error: true,
                        message: 'No value selected'
                    }
                }else {
                    this.validator.drp_reason = {
                        error: false,
                        message: '',
                    }
                }

                if(this.$store.state.userData == null) {
                    this.$store.dispatch('addNotification', {title: this.$t('notification.error'), text: this.$t('notification.abuse_not_logged_in_txt'), type: 'error'});
                    success = false;
                }

                if(success) {
                    var formData = new FormData();
                    formData.append('reporter', this.$store.state.userData.user_displayname + ' <' + this.$store.state.userData.user_email + '>');
                    formData.append('reason', this.abuseObject.id);
                    formData.append('text', this.abuseText);
                    formData.append('plugin_id', this.plugin_id);
                    axios({
                        method: 'post',
                        crossDomain: true,
                        withCredentials: true,
                        url: 'https://api.library.loxone.com/submitPluginAbuse',
                        data: formData,
                    }).then(this.$store.dispatch('addNotification', {title: this.$t('notification.success'), text: this.$t('notification.abuse_request_successfull_txt'), type: 'success'}));
                }
            },

            updateMetaValue(obj, event) {
                obj.id = event.target.value;
            },
        },
        
        created() {
            var formData = new FormData();
            formData.append('filter', JSON.stringify(this.abusePluginFilter));
            formData.append('orderby', 'plugin_downloads');
            formData.append('order', 'DESC');
            formData.append('limit', '0,1');
            formData.append('isFiltered', 'true');
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/loadFilteredPlugins',
                data: formData,
            }).then(response => {
                this.plugins = response.data
            });
        },
    }
</script>
